// extracted by mini-css-extract-plugin
export default {"formBox":"style_formBox__Yam8s","inpBox":"style_inpBox__q9BtH","heading":"style_heading__gWODT","Link":"style_Link__gPOnq"};